import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import { createContext, memo, useCallback, useContext, useMemo, useState } from "react";
// Context for left and right panel state (could be used for other panels (ie mobile) in the future)
export const AssetModalPanelsContext = /*#__PURE__*/ createContext(undefined);
export const useAssetModalPanel = ()=>{
    const ctx = useContext(AssetModalPanelsContext);
    if (!ctx) {
        const error = new Error("useAssetModalPanel must be used within AssetModalPanelsContext.Provider");
        reportErrorToBugsnag({
            error,
            context: "Asset Modal panel context not found"
        });
        throw error;
    }
    return ctx;
};
export const AssetModalPanelsContextProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [showLeftPanel, setShowLeftPanel] = useState(false);
    const [showRightPanel, setShowRightPanel] = useState(true);
    const [showContentLeftPanel, setShowContentLeftPanel] = useState(false);
    const [activeRightPanelTab, setActiveRightPanelTab] = useState("info");
    const [activeLeftContentPanel, setActiveLeftContentPanel] = useState("transcript");
    const openRightPanelWithTab = useCallback((tab)=>{
        setActiveRightPanelTab(tab);
        setShowRightPanel(true);
    }, []);
    const contextValue = useMemo(()=>({
            showLeftPanel,
            setShowLeftPanel,
            showRightPanel,
            setShowRightPanel,
            showContentLeftPanel,
            setShowContentLeftPanel,
            activeRightPanelTab,
            setActiveRightPanelTab,
            openRightPanelWithTab,
            activeLeftContentPanel,
            setActiveLeftContentPanel
        }), [
        showLeftPanel,
        showRightPanel,
        showContentLeftPanel,
        activeRightPanelTab,
        activeLeftContentPanel,
        openRightPanelWithTab
    ]);
    return /*#__PURE__*/ _jsx(AssetModalPanelsContext.Provider, {
        value: contextValue,
        children: children
    });
});
AssetModalPanelsContextProvider.displayName = "AssetModalPanelsContextProvider";
